import React from 'react';
import { Row, Col, Card, Statistic, Table, Tag } from 'antd';
import { UserOutlined, ShopOutlined, CrownOutlined, GiftOutlined } from '@ant-design/icons';
import { members, stores, getVisibleMembers, categoryOptions } from '../mockData';

const Dashboard = ({ user }) => {
  // 获取当前用户权限内的会员列表
  const visibleMembers = getVisibleMembers(user);

  // 当前用户能看到的店铺数量
  const getVisibleStoresCount = () => {
    if (user.role === 'boss') return stores.length;
    return 1; // 店长和员工只能看到自己的店铺
  };

  // 获取各个会员等级的统计数量
  const getCategoryStatistics = () => {
    const result = {};
    
    // 初始化所有类别为0
    categoryOptions.forEach(category => {
      result[category.value] = 0;
    });
    
    // 统计各类别会员数量
    visibleMembers.forEach(member => {
      if (result[member.category] !== undefined) {
        result[member.category]++;
      }
    });
    
    return result;
  };

  const categoryStats = getCategoryStatistics();

  // 最近添加的5个会员
  const recentMembers = [...visibleMembers]
    .sort((a, b) => b.id - a.id)
    .slice(0, 5);

  // 表格列定义
  const columns = [
    {
      title: '姓名',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '手机号',
      dataIndex: 'phone',
      key: 'phone',
    },
    {
      title: '会员类别',
      dataIndex: 'category',
      key: 'category',
      render: (category) => {
        const colorMap = {
          'S': '#f50',
          'A': '#87d068',
          'B': '#2db7f5',
          'C': '#999',
        };
        return (
          <Tag color={colorMap[category] || '#999'}>
            {categoryOptions.find(item => item.value === category)?.label || category}
          </Tag>
        );
      },
    },
    {
      title: '积分',
      dataIndex: 'points',
      key: 'points',
    },
  ];

  return (
    <div>
      <Row gutter={16}>
        <Col span={6}>
          <Card>
            <Statistic
              title="会员总数"
              value={visibleMembers.length}
              prefix={<UserOutlined />}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="门店数量"
              value={getVisibleStoresCount()}
              prefix={<ShopOutlined />}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="高价值会员"
              value={categoryStats['S'] + categoryStats['A']}
              prefix={<CrownOutlined />}
              valueStyle={{ color: '#cf1322' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="平均积分"
              value={visibleMembers.length ? Math.round(visibleMembers.reduce((sum, member) => sum + member.points, 0) / visibleMembers.length) : 0}
              prefix={<GiftOutlined />}
              precision={0}
            />
          </Card>
        </Col>
      </Row>

      <Card 
        title="最近会员" 
        style={{ marginTop: 16 }}
      >
        <Table 
          dataSource={recentMembers} 
          columns={columns} 
          rowKey="id"
          pagination={false}
        />
      </Card>
    </div>
  );
};

export default Dashboard; 